/*
  Retargeting LP (Brilliant Matcha)
  - Countdown: [data-rt-countdown] mit data-end (ISO-Datum). Leeres data-end übernimmt das erste gesetzte Datum der Seite.
  - Vorratsbalken: [data-rt-stock] mit data-value (Prozent), füllt sich beim Reinscrollen.
  - Kaufbox-Brücke: Paketwahl außerhalb der Kaufbox wählt die passende Box in der Produktsektion
    und legt bei Bedarf über deren echten Warenkorb-Button in den Warenkorb (Rabatt- und Geschenklogik bleibt dort).
*/
(function () {
  if (window.__rtLanding) return;
  window.__rtLanding = true;

  var designMode = window.Shopify && window.Shopify.designMode;
  var canObserve = 'IntersectionObserver' in window;
  if (!designMode && canObserve) document.documentElement.classList.add('rt-js');

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Countdown */

  // Pro Besucher: Ablauf in X Stunden plus Zufallsminuten und Sekunden, im Browser gespeichert.
  // Ist die Zeit abgelaufen, startet eine neue Runde.
  var EVERGREEN_KEY = 'rtEvergreenEnd:' + location.pathname;

  function evergreenEnd(hours) {
    var now = Date.now();
    var stored = 0;
    try { stored = parseInt(localStorage.getItem(EVERGREEN_KEY), 10) || 0; } catch (e) {}
    if (stored > now && stored - now <= (hours + 1) * 3600000) return stored;

    var end = now + hours * 3600000 + Math.floor(Math.random() * 60) * 60000 + Math.floor(Math.random() * 60) * 1000;
    try { localStorage.setItem(EVERGREEN_KEY, String(end)); } catch (e) {}
    return end;
  }

  function endFor(el) {
    var hours = parseInt(el.getAttribute('data-rt-evergreen'), 10);
    if (hours > 0) return evergreenEnd(hours);
    var v = el.getAttribute('data-end');
    return v ? Date.parse(v) : NaN;
  }

  function pageEnd() {
    var all = document.querySelectorAll('[data-rt-countdown]');
    for (var i = 0; i < all.length; i++) {
      var t = endFor(all[i]);
      if (!isNaN(t)) return t;
    }
    return NaN;
  }

  function initCountdowns() {
    var fallback = pageEnd();
    var masterEl = document.querySelector('[data-rt-countdown][data-rt-evergreen]');
    var evergreenMaster = masterEl ? parseInt(masterEl.getAttribute('data-rt-evergreen'), 10) || 0 : 0;
    var items = [];

    document.querySelectorAll('[data-rt-countdown]').forEach(function (el) {
      if (el.__rtInit) return;
      el.__rtInit = true;

      var own = endFor(el);
      var end = isNaN(own) ? fallback : own;
      if (isNaN(end)) {
        var hideTarget = el.closest('[data-rt-countdown-wrap]') || el;
        hideTarget.hidden = true;
        return;
      }

      items.push({
        el: el,
        end: end,
        evergreen: parseInt(el.getAttribute('data-rt-evergreen'), 10) || 0,
        dwrap: el.querySelector('[data-rt-dwrap]'),
        d: el.querySelector('[data-rt-d]'),
        h: el.querySelector('[data-rt-h]'),
        m: el.querySelector('[data-rt-m]'),
        s: el.querySelector('[data-rt-s]')
      });
    });

    if (!items.length) return;

    function tick() {
      var now = Date.now();
      items.forEach(function (it) {
        if (it.end <= now && (it.evergreen || evergreenMaster)) {
          it.end = evergreenEnd(it.evergreen || evergreenMaster);
        }
        var diff = Math.max(0, it.end - now);
        var t = Math.floor(diff / 1000);
        var d = Math.floor(t / 86400);
        var h = Math.floor((t % 86400) / 3600);
        var m = Math.floor((t % 3600) / 60);
        var s = t % 60;

        if (it.d) it.d.textContent = it.el.hasAttribute('data-rt-compact') ? d : pad(d);
        if (it.h) it.h.textContent = pad(h);
        if (it.m) it.m.textContent = pad(m);
        if (it.s) it.s.textContent = pad(s);
        if (it.dwrap) it.dwrap.hidden = d === 0;

        it.el.classList.toggle('is-expired', diff <= 0);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* Vorratsbalken-Karte aus <template data-rt-gallery-overlay> auf das erste Galeriebild legen */

  function initGalleryOverlay() {
    document.querySelectorAll('template[data-rt-gallery-overlay]').forEach(function (tpl) {
      if (tpl.__rtDone) return;
      var section = tpl.closest('.shopify-section');
      var media = section && section.querySelector('.product-gallery__media-slide .product-gallery__media');
      var node = tpl.content && tpl.content.firstElementChild;
      if (!media || !node) return;
      tpl.__rtDone = true;
      if (window.getComputedStyle(media).position === 'static') media.style.position = 'relative';
      media.appendChild(node.cloneNode(true));
    });
  }

  /* Vorratsbalken */

  function fillStock(el) {
    var fill = el.querySelector('[data-rt-stock-fill]');
    var value = Math.max(0, Math.min(100, parseFloat(el.getAttribute('data-value')) || 0));
    if (fill) fill.style.width = value + '%';
  }

  function initStock() {
    var bars = document.querySelectorAll('[data-rt-stock]');
    if (!bars.length) return;

    if (!('IntersectionObserver' in window)) {
      bars.forEach(fillStock);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        fillStock(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    bars.forEach(function (bar) {
      io.observe(bar);
    });
  }

  /* Einblenden beim Scrollen: [data-rt-reveal] */

  function initReveal() {
    var items = document.querySelectorAll('[data-rt-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (designMode || !canObserve) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  /* Kaufbox-Brücke */

  function buyBox() {
    var holder = document.querySelector('[data-custom-quantity-holder]');
    if (!holder) return null;
    var section = holder.closest('.shopify-section') || holder.parentNode;
    return {
      holder: holder,
      section: section,
      atc: section.querySelector('[data-add-to-cart]')
    };
  }

  function selectQuantity(qty) {
    var bb = buyBox();
    if (!bb || !qty) return bb;
    var box = bb.holder.querySelector('[data-quantity-box][data-quantity="' + qty + '"]');
    if (box) {
      if (!box.classList.contains('quantity-selector__box--active')) box.click();
      return bb;
    }
    // Keine passende Box (z. B. 5 Packungen): Menge direkt ins Feld schreiben.
    // Aktive Box zurücksetzen, damit ein späterer Klick auf eine Box wieder greift.
    var input = bb.holder.querySelector('[data-quantity-field]');
    if (input) {
      bb.holder.querySelectorAll('[data-quantity-box]').forEach(function (b) {
        b.classList.remove('quantity-selector__box--active');
      });
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return bb;
  }

  function headerOffset() {
    var offset = 16;
    var header = document.querySelector('.custom-header-listicle, [data-header-height]');
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') offset += header.offsetHeight;
    }
    return offset;
  }

  function scrollToBuyBox(bb) {
    if (!bb) return;
    // Sichtbare Paketwahl bevorzugen, die originale Auswahl ist auf den LPs ausgeblendet
    var target = bb.section.querySelector('.rt-offer, .kpl-offer') || bb.holder;
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - Math.max(headerOffset(), (window.innerHeight - rect.height) * 0.25);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function setActiveTier(option) {
    var group = option.closest('[data-rt-tiers]');
    if (!group) return;
    group.querySelectorAll('[data-rt-select]').forEach(function (o) {
      var active = o === option;
      o.classList.toggle('is-active', active);
      o.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    group.setAttribute('data-selected', option.getAttribute('data-rt-select'));

    var scope = group.closest('[data-rt-tiers-scope]');
    var total = scope && scope.querySelector('[data-rt-total]');
    if (total) total.textContent = option.getAttribute('data-total') || '';
  }

  function selectedQty(trigger) {
    var direct = trigger.getAttribute('data-rt-qty');
    if (direct) return direct;
    var scope = trigger.closest('[data-rt-tiers-scope]');
    var group = scope && scope.querySelector('[data-rt-tiers]');
    return group ? group.getAttribute('data-selected') : '';
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-rt-select]');
    if (option) {
      event.preventDefault();
      setActiveTier(option);
      selectQuantity(option.getAttribute('data-rt-select'));
      return;
    }

    var buy = event.target.closest('[data-rt-buy]');
    if (buy) {
      event.preventDefault();
      var bb = selectQuantity(selectedQty(buy));
      if (!bb) return;

      if (buy.getAttribute('data-rt-buy') === 'cart' && bb.atc && !bb.atc.disabled) {
        buy.classList.add('is-loading');
        bb.atc.click();
        setTimeout(function () { buy.classList.remove('is-loading'); }, 1800);
      } else {
        scrollToBuyBox(bb);
      }
      return;
    }

    var link = event.target.closest('a[href$="#kaufbox"]');
    if (link) {
      var bbox = selectQuantity(link.getAttribute('data-rt-qty'));
      if (!bbox) return;
      event.preventDefault();
      scrollToBuyBox(bbox);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    var option = event.target.closest && event.target.closest('[data-rt-select]');
    if (!option) return;
    event.preventDefault();
    option.click();
  });

  /* Vorauswahl: erstes [data-rt-preselect] auf der Seite gibt die Paketgröße in der Kaufbox vor */

  function preselect() {
    var el = document.querySelector('[data-rt-preselect]');
    var qty = el && el.getAttribute('data-rt-preselect');
    if (!qty) return;
    selectQuantity(qty);
    var option = document.querySelector('[data-rt-tiers] [data-rt-select="' + qty + '"]');
    if (option) setActiveTier(option);
  }

  // Läuft erst nach DOMContentLoaded, weil die Produktsektion ihre Box-Klicks dort bindet
  function afterDomContentLoaded(fn) {
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var done = nav ? nav.domContentLoadedEventEnd > 0 : document.readyState === 'complete';
    if (done) {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); });
    }
  }

  function init() {
    initGalleryOverlay();
    initCountdowns();
    initStock();
    initReveal();
    afterDomContentLoaded(preselect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initGalleryOverlay();
    initCountdowns();
    initStock();
    initReveal();
  });
})();
